
import { url } from "./baseurl";
import axios from "axios";

// user API
export const loginCheck = async (email, password) => {
  try {
    const response = await axios.post(url + "/login", { email, password });
    return response.data;
  } catch (error) {
    throw new Error(`Failed to send data: ${error.message}`);
  }
};


export const addSuperadmin = async (data) => {
  try {
    const response = await axios.post(url + "/superadmin", {action : 'addSuperadmin', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch data: ${error.message}`);
  }
};


export const getUser = async (token) => {
  try {
    const response = await axios.get(url + "/getUser", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch data");
  }
};

// Team Lead API
export const getTeamLeads = async (data) => {
  try {
    const response = await axios.post(url + "/teamleads", {action : 'getTeamLeads', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch data: ${error.message}`);
  }
};

export const addTeamLead = async (data) => {
  try {
    const response = await axios.post(url + "/teamleads", {action : 'addTeamLead', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch data: ${error.message}`);
  }
};

export const editTeamLead = async (data) => {
  try {
    const response = await axios.post(url + "/teamleads", {action : 'editTeamLead', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch data: ${error.message}`);
  }
};

export const deleteTeamLead = async (data) => {
  try {
    const response = await axios.post(url + "/teamleads", {action : 'deleteTeamLead', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch data: ${error.message}`);
  }
};

// Studio API
export const getStudios = async (data) => {
  try {
    const response = await axios.post(url + "/studios", {action : 'getStudios', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to send data: ${error.message}`);
  }
};

export const getStudiosOption = async (data) => {
  try {
    const response = await axios.post(url + "/studios", {action : 'getStudiosOption', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to send data: ${error.message}`);
  }
};

export const addStudio = async (data) => {
  try {
    const response = await axios.post(url + "/studios", {action : 'addStudio', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to send data: ${error.message}`);
  }
};

export const editStudio = async (data) => {
  try {
    const response = await axios.post(url + "/studios", {action : 'editStudio', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to send data: ${error.message}`);
  }
};

export const deleteStudio = async (data) => {
  try {
    const response = await axios.post(url + "/studios", {action : 'deleteStudio', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to send data: ${error.message}`);
  }
};

export const getStudioData = async (data) => {
  try {
    const response = await axios.post(url + "/studios", {action : 'getStudioData', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to send data: ${error.message}`);
  }
};

// Addons API
export const getAddons = async (data) => {
  try {
    const response = await axios.post(url + "/addons", {action : 'getAddons', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to send data: ${error.message}`);
  }
};

export const getAddonData = async (data) => {
  try {
    const response = await axios.post(url + "/addons", {action : 'getAddonData', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to send data: ${error.message}`);
  }
};

export const addAddons = async (data) => {
  try {
    const response = await axios.post(url + "/addons", {action : 'addAddons', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to send data: ${error.message}`);
  }
};

export const editAddons = async (data) => {
  try {
    const response = await axios.post(url + "/addons", {action : 'editAddons', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to send data: ${error.message}`);
  }
};

export const deleteAddons = async (data) => {
  try {
    const response = await axios.post(url + "/addons", {action : 'deleteAddons', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to send data: ${error.message}`);
  }
};

// Leads API
export const addLeads = async (data) => {
  try {
    const response = await axios.post(url + "/leads", {action : 'addLeads', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to send data: ${error.message}`);
  }
};

export const importLeads = async (data) => {
  try {
    const response = await axios.post(url + "/leads", {action : 'importLeads', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to send data: ${error.message}`);
  }
};

export const getLeads = async (data) => {
  try {
    const response = await axios.post(url + "/leads", {action : 'getLeads', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to send data: ${error.message}`);
  }
};

export const editLeads = async (data) => {
  try {
    const response = await axios.post(url + "/leads", {action : 'editLeads', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to send data: ${error.message}`);
  }
};

export const getBookingData = async (data) => {
  try {
    const response = await axios.post(url + "/leads", {action : 'getBookingData', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to send data: ${error.message}`);
  }
};

export const deleteLeads = async (data) => {
  try {
    const response = await axios.post(url + "/leads", {action : 'deleteLeads', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to send data: ${error.message}`);
  }
};

// User API
export const getUsers = async (data) => {
  try {
    const response = await axios.post(url + "/users", {action : 'getUsers', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch data: ${error.message}`);
  }
};

export const addUser = async (data) => {
  try {
    const response = await axios.post(url + "/users", {action : 'addUser', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch data: ${error.message}`);
  }
};

export const editUser = async (data) => {
  try {
    const response = await axios.post(url + "/users", {action : 'editUser', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch data: ${error.message}`);
  }
};

export const deleteUser = async (data) => {
  try {
    const response = await axios.post(url + "/users", {action : 'deleteUser', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch data: ${error.message}`);
  }
};




// Forgot Password
export const sendOTP = async (data) => {
  try {
    const response = await axios.post(url + "/forgotpassword", {action : 'sendOTP', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch data: ${error.message}`);
  }
};


export const verifyOTP = async (data) => {
  try {
    const response = await axios.post(
      url + "/forgotpassword",
      { action: "verifyOTP", data },
      
    );
    return response.data;
  } catch (error) {
    console.error("Error verifying OTP:", error);
    throw error;
  }
};


export const changePassword = async (data) => {
  try {
    const response = await axios.post(url + "/forgotpassword", {action : 'changePassword', data});
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch data: ${error.message}`);
  }
};